<template>
  <div class="side-panel">
    <PlotDetailPanel
      v-if="selectedPlot"
      :plot="plotDetail"
      :loading="plotLoading"
      @close="$emit('close-plot')"
      @open-ticket="$emit('open-ticket', $event)"
      @status-changed="$emit('plot-status-changed', $event)"
      @deleted="$emit('plot-deleted')"
    />
    <template v-else-if="showAllAlerts">
      <div class="side-panel__all-alerts-header">
        <span class="side-panel__all-alerts-title">Todas las alertas</span>
        <button class="side-panel__all-alerts-close" @click="$emit('close-all-alerts')">
          <span class="mdi mdi-close"></span>
        </button>
      </div>
      <div class="side-panel__all-alerts-body">
        <AlertsPanel
          :alerts="alerts"
          @alert-action="$emit('alert-action', $event)"
          @alert-dismiss="$emit('alert-dismiss', $event)"
        />
      </div>
    </template>
    <template v-else>
      <AreaDistributionCard
        :plots="plots"
        :active-filter="activeFilter"
        @update:active-filter="$emit('update:activeFilter', $event)"
      />
      <OccupancyChart :history="occupancyHistory" />
    </template>
  </div>
</template>

<script setup>
import PlotDetailPanel from './PlotDetailPanel.vue'
import AreaDistributionCard from './AreaDistributionCard.vue'
import OccupancyChart from './OccupancyChart.vue'
import AlertsPanel from './AlertsPanel.vue'

defineProps({
  selectedPlot: { type: Object, default: null },
  plotDetail: { type: Object, default: null },
  plotLoading: { type: Boolean, default: false },
  plots: { type: Array, default: () => [] },
  activeFilter: { type: String, default: null },
  occupancyHistory: { type: Array, default: () => [] },
  showAllAlerts: { type: Boolean, default: false },
  alerts: { type: Array, default: () => [] },
})

defineEmits(['close-plot', 'update:activeFilter', 'close-all-alerts', 'alert-action', 'alert-dismiss', 'open-ticket', 'plot-status-changed', 'plot-deleted'])</script>

<style scoped>
.side-panel {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  height: 100%;
  min-height: 0;
}

.side-panel__all-alerts-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.side-panel__all-alerts-title {
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 0.85rem;
  color: var(--text-content);
}

.side-panel__all-alerts-close {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--text-secondary);
  font-size: 1rem;
  padding: 0.2rem;
}

.side-panel__all-alerts-close:hover {
  color: var(--text-content);
}

.side-panel__all-alerts-body {
  flex: 1;
  min-height: 0;
}
</style>